import { render } from "./PxPLinkPage.vue?vue&type=template&id=7a4ca688&scoped=true"
import script from "./PxPLinkPage.vue?vue&type=script&lang=js"
export * from "./PxPLinkPage.vue?vue&type=script&lang=js"

import "./PxPLinkPage.vue?vue&type=style&index=0&id=7a4ca688&lang=css"
import "./PxPLinkPage.vue?vue&type=style&index=1&id=7a4ca688&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4ca688"]])

export default __exports__